import React, { Component, Fragment } from "react";
import {
    Button, Menu, MenuItem, CircularProgress,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
    Typography,
} from "@material-ui/core";
import agent from "../../agent";

// Reuse the existing PaymentDetails CSS — same class names, same visual language.
import "../billing/PaymentDetails.css";

const HOT_PINK = "#fe0d9d";

class HGSuperPayManageCard extends Component {
    state = {
        cards: [],
        defaultPM: "",
        loading: true,
        actionLoading: false,
        error: false,
        actionAnchor: {},
        deleteConfirmCardId: null, // pmId pending confirmation, or null when dialog is closed
    };

    componentDidMount() {
        this._loadCards();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.profileId !== this.props.profileId) {
            this._loadCards();
        }
    }

    _loadCards() {
        const { profileId } = this.props;
        if (!profileId) {
            this.setState({ loading: false, cards: [], defaultPM: "", error: false });
            return;
        }
        this.setState({ loading: true, error: false });
        agent.HgSuperPayAddon.getCard(profileId)
            .then(response => {
                const data = response?.data || response;
                this.setState({
                    loading: false,
                    cards: data?.cards?.data || [],
                    defaultPM: data?.defaultPM || "",
                });
            })
            .catch(() => {
                this.setState({ loading: false, error: true });
            });
    }

    addCard = () => {
        const { profileId, isOrganisation } = this.props;
        if (!profileId) return;
        this.setState({ actionLoading: true });
        agent.HgSuperPayAddon.addCard(profileId, isOrganisation)
            .then(response => {
                const data = response?.data || response;
                const url = data?.url || data?.checkoutUrl;
                if (url) window.open(url, "_blank");
                this.setState({ actionLoading: false });
            })
            .catch(() => {
                this.setState({ actionLoading: false });
            });
    };

    setDefaultCard = (pmId) => {
        const { profileId } = this.props;
        if (!profileId) return;
        this.setState({ actionLoading: true });
        this._closeMenu();
        agent.HgSuperPayAddon.setDefaultCard(profileId, pmId)
            .then(() => {
                this.setState({ defaultPM: pmId, actionLoading: false });
            })
            .catch(() => {
                this.setState({ actionLoading: false });
            });
    };

    requestDeleteCard = (pmId) => {
        this._closeMenu();
        this.setState({ deleteConfirmCardId: pmId });
    };

    confirmDeleteCard = () => {
        const { profileId } = this.props;
        const pmId = this.state.deleteConfirmCardId;
        if (!profileId || !pmId) return;
        this.setState({ actionLoading: true, deleteConfirmCardId: null });
        agent.HgSuperPayAddon.deleteCard(profileId, pmId)
            .then(() => {
                this.setState(prev => ({
                    cards: prev.cards.filter(c => c.id !== pmId),
                    defaultPM: prev.defaultPM === pmId ? "" : prev.defaultPM,
                    actionLoading: false,
                }));
            })
            .catch(() => {
                this.setState({ actionLoading: false });
            });
    };

    _openMenu = (element, cardId) => {
        this.setState(prev => ({ actionAnchor: { ...prev.actionAnchor, [cardId]: element } }));
    };

    _closeMenu = () => {
        this.setState({ actionAnchor: {} });
    };

    getCardBrandIcon = (brand) => {
        switch (brand) {
            case "visa":       return "fa-brands fa-cc-visa";
            case "mastercard": return "fa-brands fa-cc-mastercard";
            case "amex":       return "fa-brands fa-cc-amex";
            case "discover":   return "fa-brands fa-cc-discover";
            default:           return "fa-solid fa-credit-card";
        }
    };

    getCardBrandClass = (brand) => {
        switch (brand) {
            case "visa":       return "visa";
            case "mastercard": return "mastercard";
            case "amex":       return "amex";
            case "discover":   return "discover";
            default:           return "default-icon";
        }
    };

    renderCard = (data) => {
        const { defaultPM, actionAnchor } = this.state;
        const isDefault   = data.id === defaultPM;
        const brandIcon   = this.getCardBrandIcon(data?.card?.brand);
        const brandClass  = this.getCardBrandClass(data?.card?.brand);
        const holderName  = data?.billing_details?.name || "Card Holder";

        return (
            <div key={data.id} className={`payment-card ${isDefault ? "default" : ""}`}>
                <div className="payment-card-header">
                    <div className="payment-card-brand">
                        <i className={`${brandIcon} payment-card-brand-icon ${brandClass}`} />
                        <div className="payment-card-info-mobile">
                            <span className="payment-card-number">
                                •••• {data?.card?.last4}
                                {isDefault && <span className="default-badge-inline">Default</span>}
                            </span>
                            <div className="payment-card-details-inline">
                                {holderName} · Expires {data?.card?.exp_month}/{data?.card?.exp_year}
                            </div>
                        </div>
                    </div>
                    <Button
                        className="payment-card-menu-btn"
                        onClick={e => this._openMenu(e.currentTarget, data.id)}
                        aria-label="Card actions menu"
                    >
                        <i className="fa-solid fa-ellipsis-vertical" />
                    </Button>
                    <Menu
                        open={actionAnchor[data.id] != null}
                        onClose={this._closeMenu}
                        anchorEl={actionAnchor[data.id]}
                    >
                        {!isDefault && (
                            <MenuItem onClick={() => this.setDefaultCard(data.id)}>
                                <i className="fa-solid fa-check" style={{ marginRight: 10, width: 16 }} />
                                Set as Default
                            </MenuItem>
                        )}
                        <MenuItem
                            onClick={() => this.state.cards.length > 1 && this.requestDeleteCard(data.id)}
                            disabled={this.state.cards.length <= 1}
                            title={this.state.cards.length <= 1 ? "You must have at least one payment method" : undefined}
                            style={{ color: this.state.cards.length > 1 ? "#e53935" : undefined }}
                        >
                            <i className="fa-solid fa-trash" style={{ marginRight: 10, width: 16 }} />
                            Delete Card
                        </MenuItem>
                    </Menu>
                </div>
                <div className="payment-card-details">
                    <div className="payment-card-holder">{holderName}</div>
                    <div className="payment-card-expiry">
                        Expires {data?.card?.exp_month}/{data?.card?.exp_year}
                    </div>
                </div>
                <div className="payment-card-footer">
                    {isDefault && <span className="default-badge">Default</span>}
                </div>
            </div>
        );
    };

    renderEmpty() {
        return (
            <div className="empty-state">
                <div className="empty-state-icon">
                    <i className="fa-solid fa-credit-card" />
                </div>
                <h3>No payment methods saved yet</h3>
                <p>Add a card to pay for this venue's subscription</p>
                <Button className="btn-add-first" onClick={this.addCard}>
                    <i className="fa-solid fa-plus" />
                    Add Your First Card
                </Button>
            </div>
        );
    }

    renderError() {
        return (
            <div style={{ textAlign: "center", padding: "60px 24px" }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: "#333", marginBottom: 8 }}>
                    Could not load payment methods
                </div>
                <div style={{ fontSize: 13.5, color: "#888", marginBottom: 20 }}>
                    An error occurred. Please try again.
                </div>
                <Button
                    variant="contained"
                    style={{ backgroundColor: HOT_PINK, color: "#fff" }}
                    onClick={() => this._loadCards()}
                >
                    Retry
                </Button>
            </div>
        );
    }

    render() {
        const { loading, error, cards, actionLoading } = this.state;

        if (loading) {
            return (
                <div style={{ padding: "60px 0", display: "flex", justifyContent: "center" }}>
                    <CircularProgress style={{ color: HOT_PINK }} />
                </div>
            );
        }

        if (error) return this.renderError();

        const hasCards = cards && cards.length > 0;

        const { deleteConfirmCardId } = this.state;
        const cardToDelete = deleteConfirmCardId ? cards.find(c => c.id === deleteConfirmCardId) : null;
        const last4 = cardToDelete?.card?.last4;

        return (
            <Fragment>
                {actionLoading && (
                    <div style={{ display: "flex", justifyContent: "center", padding: "12px 0" }}>
                        <CircularProgress size={24} style={{ color: HOT_PINK }} />
                    </div>
                )}
                <div className="payment-methods-section">
                    <div className="payment-methods-header">
                        <Button className="btn-add-card" onClick={this.addCard} disabled={actionLoading}>
                            <i className="fa-solid fa-plus" />
                            Add Card
                        </Button>
                    </div>
                    {hasCards ? (
                        <div className="payment-cards-grid">
                            {cards.map(card => this.renderCard(card))}
                        </div>
                    ) : (
                        this.renderEmpty()
                    )}
                </div>

                {/* Delete card confirmation dialog */}
                <Dialog
                    open={!!deleteConfirmCardId}
                    onClose={() => this.setState({ deleteConfirmCardId: null })}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle style={{ backgroundColor: "#d32f2f", padding: "12px 24px" }} disableTypography>
                        <Typography variant="title" style={{ color: "#fff", fontWeight: 700 }}>
                            Remove Payment Method?
                        </Typography>
                    </DialogTitle>
                    <DialogContent style={{ paddingTop: 20 }}>
                        <DialogContentText>
                            {last4
                                ? <>Are you sure you want to remove the card ending in <strong>{last4}</strong>?</>
                                : "Are you sure you want to remove this card?"}
                        </DialogContentText>
                        <DialogContentText style={{ marginTop: 10 }}>
                            This action cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ padding: "12px 20px" }}>
                        <Button
                            onClick={() => this.setState({ deleteConfirmCardId: null })}
                            style={{ color: "#888" }}
                        >
                            Keep Card
                        </Button>
                        <Button
                            variant="contained"
                            onClick={this.confirmDeleteCard}
                            style={{ backgroundColor: "#d32f2f", color: "#fff", fontWeight: 700 }}
                        >
                            Yes, Remove
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

export default HGSuperPayManageCard;
